import React from 'react'
import IconClose from 'assets/icons/icon-close.svg'
import { Modal, Button} from 'antd'
import IconDevice from 'assets/images/payment/package-01.svg'
import IconStat from 'assets/images/payment/package-02.svg'
import styles from './ModalGetPackage.module.scss'
const ModalGetPackage = ({
  visible,
  handleCancel,
  props
}) => {
  return(
    <div>
      <Modal
        visible={visible}
        footer={null}
        onCancel = {handleCancel}
        width = {540}
        closeIcon = {<img alt = 'IconClose' src = {IconClose}/>}
      >
        <div className = {styles.rootModal}>
          <h1>หมดระยะเวลาทดลองใช้งาน</h1>
          <div className = {styles.detail}>
            ซื้อแพ็กเกจเพื่อใช้งานต่อ ค่าบริการเพียง ฿479/ปี
          </div>
          <div className = {styles.content}>
            <div style = {{display : 'flex', justifyContent : 'center', flexWrap : 'wrap', width : '50%'}}>
              <div className = {styles.circle}>
                <img alt = 'IconDevice' src = {IconDevice}/>
              </div>
              <div className = {styles.txtLabel}>
              ใช้งานได้ทุก Device
              </div>
            </div>
            <div style = {{display : 'flex', justifyContent : 'center', flexWrap : 'wrap', width : '50%'}}>
              <div className = {styles.circleTwo}>
                <img alt = 'IconStat' src = {IconStat}/>
              </div>
              <div className = {styles.txtLabel}>
              เก็บสถิติติดตามผลสอบ
              </div>
            </div>
          </div>
        </div>
        <div className = {styles.txtSubLabel}>
        ไม่มีสัญญาผูกมัด สามารถยกเลิกได้เมื่อต้องการ
        </div>
        <div style = {{textAlign : 'center', marginTop : 16}}>
          <Button style = {{width: 350, height : 48}} type = 'primary'
            onClick = {()=>{
              if (props?.history) {
                props.history.push('/package')
              }
            }}
          >ซื้อแพ็กเกจ</Button>
        </div>
      </Modal>
    </div>
  )     
}
export default ModalGetPackage